<template>
  <div>
    <h2>Status Updates</h2>
    <v-data-table
      style="width: 100%"
      :headers="headers"
      :items="statusUpdates"
      item-key="index"
      dense
      hide-default-footer
    >
      <template v-slot:[`item.createdAt`]="{ item }">
        {{ item.createdAt | moment("MM/DD/YYYY") }}
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: "StatusUpdateList",
  props: ["statusUpdates"],
  data() {
    return {
      headers: [
        { text: "Status", value: "subject" },
        { text: "Date", value: "createdAt" },
        { text: "Details", value: "text" },
      ],
    };
  },
};
</script>

<style></style>
